<template>
  <fragment v-if="documents.length > 0">
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col"
              style="border: 0px;"></th>
          <th scope="col"
              class="borderHide"
              style="font-size: 16px; color: #333; font-weight: 600;">Document Name</th>

          <th scope="col"
              class="borderHide"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(doc, index) in documents"
            :key="index">
          <th scope="row">
            <i class="fa fa-file"
               style="font-size: 16px; color: #333;"></i>
          </th>
          <td style="font-size: 15px; vertical-align: middle;">{{ doc.name }}</td>

          <td class="text-right" style="vertical-align: middle;">
            <a class="btn btn-danger el-button--default mr-2"
               target="_blank"
               :href="doc.fileURL"
               style="background-color: #ff3b1d; border-color: #ff3b1d; box-shadow: 0 2px 4px rgba(0,0,0,0.2); font-size: 13px; padding: 5px 15px;">
              View
            </a>
            <a href="#"
               class="btn btn-danger el-button--default"
               @click.prevent="remove(index, doc.id)"
               style="background-color: #ff3b1d; border-color: #ff3b1d; box-shadow: 0 2px 4px rgba(0,0,0,0.2); font-size: 13px; padding: 5px 15px;">
              Remove
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </fragment>
</template>

<script>
import { dateFormatter } from '@Views/Screening/utility/common';
import { File } from "@Views/Screening/utility/apiAgent";

export default {
  name: "DocumentTable",
  props: {
    documents: {
      type: Array
    }
  },
  data() {
    return {}
  },
  methods: {
    dateFormatter,
    remove(index, applicantFileId) {
      File.deleteDocument(applicantFileId)
        .then(({ data }) => {
          this.documents.splice(index, 1);
          //Fire an Event With Id of File.
          this.$emit('onDelete', index);
          this.$toastr.s(data.message);
        });
    },
  }
}
</script>

<style scoped>
.borderHide {
  border-left: 1px;
  border-right: 1px;
  border-top: 0px;
  border-bottom: 0px;
}
</style>